import { optional } from '@lib/iots';
import * as t from 'io-ts';

export const salesforceWebToLead = t.intersection([
    t.type({
        lastName: t.string,
        firstName: t.string,
        email: t.string,
        googlePlaceID: t.string,
        bedrooms: t.number,
        bathrooms: t.number,
    }),
    t.partial({
        address: t.type({
            street: t.string,
            city: t.string,
            state: t.string,
            country: t.string,
            zipCode: t.string,
        }),
        sfLeadId: optional(t.string),
        sfContactId: optional(t.string),
        sfOpportunityId: optional(t.string),
        sfUnitId: optional(t.string),
        sfUnitRoleId: optional(t.string),
        sfCampaignId: optional(t.string),
        phone: optional(t.string),
        utmCampaign: optional(t.string),
        utmSource: optional(t.string),
        utmMedium: optional(t.string),
        utmTerm: optional(t.string),
        utmContent: optional(t.string),
        vestimateAmt: optional(t.number),
        campaignName: optional(t.string),
        homeType: optional(t.string),
        bedroomData: optional(
            t.type({
                twin: t.number,
                queen: t.number,
                king: t.number,
            }),
        ),
        surroundings: optional(t.string),
        amenities: optional(t.string),
        dogFriendly: optional(t.boolean),
        nightlyRates: optional(
            t.type({
                peakSeason: t.type({
                    min: t.number,
                    max: t.number,
                }),
                offSeason: t.type({
                    min: t.number,
                    max: t.number,
                }),
            }),
        ),
        ownerHolds: optional(
            t.array(
                t.type({
                    startDate: t.string,
                    endDate: t.string,
                }),
            ),
        ),
        premiumServices: optional(t.string),
        generatedPDF: optional(t.unknown),
    }),
]);
